// extracted by mini-css-extract-plugin
export default {"ads__section":"style_ads__section__yc+ct","box":"style_box__-3y5T","box__text":"style_box__text__PndKc","box__img":"style_box__img__2EhXS"};